var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 198.86 161.62",
      },
    },
    [
      _c("path", {
        staticStyle: { fill: "#ffffff" },
        attrs: {
          d: "M63.07,181.22c75,0,116.09-62.17,116.09-116.09q0-2.65-.12-5.27A83,83,0,0,0,199.4,38.73,81.36,81.36,0,0,1,176,45.16a41,41,0,0,0,17.94-22.57A81.83,81.83,0,0,1,168,32.49,40.83,40.83,0,0,0,98.47,69.7a115.85,115.85,0,0,1-84.1-42.63A40.84,40.84,0,0,0,27,81.54a40.5,40.5,0,0,1-18.48-5.1c0,.17,0,.34,0,.52a40.81,40.81,0,0,0,32.73,40,40.73,40.73,0,0,1-18.43.7A40.84,40.84,0,0,0,60.94,146a81.85,81.85,0,0,1-50.67,17.46,82.87,82.87,0,0,1-9.73-.56,115.49,115.49,0,0,0,62.54,18.33",
          transform: "translate(-0.53 -19.6)",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }